import React, { FC } from 'react'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import {
  ModuleContext,
  Module,
  ModuleSimplifiedMultiBuyTabs,
  ModuleSimplifiedTabs,
} from '../../types'
import { useProductStore } from '../../../contexts/product'
import { useTracking } from '../../../contexts/tracking'
import { SimplifiedTabsModule } from '../SimplifiedTabs'

const MULTI_BUY_TAB_DEFAULT_QUANTITY = 5

type Props = {
  tabModule: ModuleSimplifiedMultiBuyTabs
  context: ModuleContext
  mapModule: (module: Module, props: ModuleContext) => React.JSX.Element | null
}

export const SimplifiedMultiBuyTabsModule: FC<Props> = ({
  tabModule,
  context,
  mapModule,
}) => {
  const [_, productStoreDispatcher] = useProductStore()
  const { selectContent } = useTracking()

  // Added 2025-Apr-29 to support analytics internal training,
  // discuss with Russell Allen or Matthew Jenner before removing
  useExperiment('pricing-aa-1', { fallback: 'fallback' })
  useExperiment('pricing-aa-2', { fallback: 'fallback' })
  useExperiment('pricing-aa-3', { fallback: 'fallback' })
  const handleOnChanged = (tab: { title: string }, index: number) => {
    productStoreDispatcher.reset()

    if (index === 1) {
      productStoreDispatcher.selectQuantity(MULTI_BUY_TAB_DEFAULT_QUANTITY)
    }

    selectContent({
      action: tabModule.meta.intent,
      component: 'tab',
      label: tab.title,
    })
  }

  return (
    <SimplifiedTabsModule
      context={context}
      module={tabModule as unknown as ModuleSimplifiedTabs}
      mapModule={mapModule}
      onChanged={handleOnChanged}
      data-testid="module-simplified-multi-buy-tabs"
    />
  )
}
